import { useMemo } from 'react';

import { compareNestedKeysForSort } from './TreeSelect.helpers';
import type { NestedKeySort } from './TreeSelect.types';

export function useNestedKeyComparator(nestedKeySort: NestedKeySort): (a: string, b: string) => number {
  return useMemo(() => (a: string, b: string) => compareNestedKeysForSort(nestedKeySort, a, b), [nestedKeySort]);
}
